module.exports = __webpack_public_path__ + "static/media/cq_simulazione.5f52fc65.svg";